import KoobInputSelect from '@koob/ui/src/components/KoobInputSelect';
import { useTripFilters } from '../../hooks/useTripStoreSelectors';
import { useUpdateTripFilter } from '../../hooks/useUpdateTripFilter';
import {
  pickByIds,
  toLimitedOptions,
  toOptions,
  type FilterItem,
} from '../../logic/tripFilterOptions';

interface Props {
  // The tripFilters property that holds the picked api objects.
  property: 'themes' | 'segments' | 'categories' | 'kinds' | 'styles';
  placeholder: string;
  items: FilterItem[];
  loading: boolean;
  // Caps the picks at three (themes, segments).
  limited?: boolean;
}

// A multi select over a list of api objects ({ id, displayName }). The filter
// keeps the objects; the select gets their ids.
export default function TripFilterMultiSelect({
  property,
  placeholder,
  items,
  loading,
  limited,
}: Props) {
  const tripFilters = useTripFilters();
  const updateFilter = useUpdateTripFilter();
  const selected: FilterItem[] = tripFilters?.[property] || [];

  return (
    <div className="w-48">
      <KoobInputSelect
        rounded="full"
        placeholder={placeholder}
        multiple
        loading={loading}
        options={limited ? toLimitedOptions(items, selected) : toOptions(items)}
        value={selected.map((item) => item.id)}
        onValueChange={(ids: Array<number | string>) =>
          updateFilter(property, pickByIds(items, ids))
        }
        clearable
      />
    </div>
  );
}
